export default "__VITE_ASSET__8279a37e__"